<template>
  <div>
    <template v-if="sortedSubEvents.length == 0">
      <v-row align="center" justify="center" class="my-10">
        <v-col cols="12" class="d-flex flex-column justify-center align-center">
          <v-img
            src="@/assets/add-sub-event-icon.svg"
            height="50"
            class="text-center"
            contain
            width="50"
          ></v-img>
          <div class="text-subtitle-1 font-weight-bold mt-2">
            There are no sub-events
          </div>
          <div>Start adding sub-events and sessions that runs under them.</div>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn large class="primary" depressed @click="handleAddSubEvent"
            ><v-icon>mdi-plus</v-icon>Add sub-event</v-btn
          >
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row class="mt-5">
        <v-col cols="12" sm="6" md="8">
          <v-btn large class="primary" depressed @click="handleAddSubEvent"
            ><v-icon>mdi-plus</v-icon>Add sub-event</v-btn
          >
        </v-col>
        <v-col md="4" sm="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            outlined
            single-line
            hide-details
            placeholder="Search for a sub-event"
            rounded
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12">
          <v-data-table
            :headers="headers"
            :items="sortedSubEvents"
            @click:row="handleEdit"
            :items-per-page="8"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <v-list-item class="pl-0">
                <v-sheet class="rounded-lg mr-2" v-if="item.coverImageURL">
                  <v-img
                    class="rounded-lg"
                    width="51.03"
                    height="33.75"
                    max-width="51.03"
                    max-height="33.75"
                    :src="item.coverImageURL"
                  >
                  </v-img>
                </v-sheet>
                <v-sheet
                  v-else
                  flat
                  class="rounded-lg mr-2 circle d-flex justify-center align-center"
                  width="51.03"
                  height="33.75"
                  max-width="51.03"
                  max-height="33.75"
                >
                  <v-sheet
                    :class="[
                      ' d-flex justify-center align-center dashed-border     rounded-lg',
                    ]"
                    width="51.03"
                    height="33.75"
                    max-width="51.03"
                    max-height="33.75"
                  >
                    <div class="grey--text text-center logo-text">
                      Add your image
                    </div>
                  </v-sheet>
                </v-sheet>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:item.date="{ item }">
              <div>
                {{ getSubEventDate(item) }}
              </div>
            </template>
            <template v-slot:item.time="{ item }">
              <div>
                {{ getSubEventTime(item) }}
              </div>
            </template>
            <template v-slot:item.session="{ item }">
              {{ getNoOfSessions(item) }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list nav>
                  <v-list-item @click="handleEdit(item)">
                    <v-list-item-title>Edit sub-event</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="handleDelete(item)">
                    <v-list-item-title>Delete sub-event</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <ConfirmationDialog
        :show="showConfirmationDialog"
        :title="confirmationDialogTitle"
        :content="confirmationDialogContent"
        @click="deleteSubEvent"
        @closeDialog="showConfirmationDialog = false"
        buttonText="Delete sub-event"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Event from "@/models/Event";
import constants from "@/shared/constants";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import {onSnapshot, where} from "firebase/firestore";
import {deleteEventDoc, queryEventCollection} from "@/shared/firebase_utils";

export default {
  data() {
    return {
      subEvent: null,
      headers: [
        {
          text: "Sub-event name",
          value: "name",
          align: "start",
        },
        {
          text: "Date",
          value: "date",
          align: "start",
        },
        {
          text: "Time",
          value: "time",
          align: "start",
        },
        {
          text: "Session",
          value: "session",
          align: "start",
        },
        { text: "Actions", value: "action" },
      ],
      linkedSubEvents: [],
      unsubscribeSubEventsSnapshot: null,
      search: "",
      showConfirmationDialog: false,
      confirmationDialogTitle: "",
      confirmationDialogContent: "",
      subEventToBeDeleted: null,
    };
  },
  components: {
    ConfirmationDialog,
  },
  computed: {
    ...mapGetters([
      "selectedBusinessProfileId",
      "businessProfile",
      "currentSubEvent",
      "currentEvent",
      "userProfile",
      // "linkedSubEvents",
    ]),
    sortedSubEvents() {
      let sortedArray = this.linkedSubEvents.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.startDateTime) - new Date(b.startDateTime);
      });
      return sortedArray;
    },
  },
  created() {
    try {

      this.unsubscribeSubEventsSnapshot =
        onSnapshot(
            queryEventCollection(
                where("businessProfileId", "==", this.userProfile.businessProfileId),
                where("parentMultiConnectEventId", "==", this.currentEvent.id),
                where("parentSubEventId", "==", "")
            ),
            (querySnapshot) => {
          const changes = querySnapshot.docChanges();
          changes.forEach((change) => {
            this.handleDocumentChange(change);
          });
        });
    } catch (error) {
      console.log(
        "Error occurred while fetching snapshot of events for super user: ",
        error
      );
    }
    // Get linked sub-events for this parent event
    // this.unsubscribeSubEventsSnapshot = this.initializeLinkedSubEvents({
    //   parentEventId: this.currentEvent.id,
    //   businessProfileId: this.userProfile.businessProfileId,
    // });
  },
  destroyed() {
    this.unsubscribeSubEventsSnapshot();
  },
  methods: {
    ...mapActions([
      "setCurrentSubEvent",
      "showSnackbar",
      // "initializeLinkedSubEvents",
    ]),
    async handleAddSubEvent() {
      this.subEvent = new Event({
        businessProfileId: this.selectedBusinessProfileId,
        hostName: this.businessProfile.businessName,
        isCreationInProgress: true,
        parentMultiConnectEventId: this.currentEvent.id,
        currentStep: "EVENT_DETAILS",
        linkPrivacy: this.currentEvent.linkPrivacy,
        eventCategory: constants.EVENT_CATEGORY.subEvent,
      });

      this.setCurrentSubEvent(this.subEvent);

      await this.currentSubEvent.generateEventId();

      this.$router.push({
        name: "addEditSubEvent",
        params: {
          eventId: this.currentEvent.id,
          subEventId: this.currentSubEvent.id,
        },
      });
    },
    handleEdit(subEvent) {
      this.setCurrentSubEvent(subEvent);
      this.$router.push({
        name: "addEditSubEvent",
        params: {
          subEventId: this.currentSubEvent.id,
        },
        query:{
          tab:0
        }
      });
    },
    handleDocumentChange(change) {
      let addedSubEvent;
      if (change.type === "added" || change.type == "modified") {
        //let data = change.doc.data({ serverTimestamps: "estimate" });
        addedSubEvent = Event.fromFireStore(change.doc);
      }
      if (change.type === "added") {
        if (
          this.linkedSubEvents.length != 0 &&
          addedSubEvent.createdAt > this.linkedSubEvents[0].createdAt
        ) {
          this.linkedSubEvents.unshift(addedSubEvent);
        } else {
          this.linkedSubEvents.push(addedSubEvent);
        }
      } else if (change.type == "modified") {
        console.log("modified");
        //Replace the old object within the array with the modified object
        this.linkedSubEvents.forEach((item, index) => {
          if (item.id == change.doc.id) {
            this.linkedSubEvents.splice(index, 1, addedSubEvent);
          }
        });
      } else if (change.type == "removed") {
        //Remove the object from the array
        this.linkedSubEvents.forEach((item, index) => {
          if (item.id == change.doc.id) {
            this.linkedSubEvents.splice(index, 1);
          }
        });
      }
    },
    getSubEventDate(subEvent) {
      return (
        new Intl.DateTimeFormat("en-US", {
          weekday: "long",
          timeZone: subEvent.timezone || this.currentEvent.timezone,
        }).format(subEvent.startDateTime) +
        ", " +
        new Intl.DateTimeFormat("en-US", {
          dateStyle: "medium",
          timeZone: subEvent.timezone || this.currentEvent.timezone,
        }).format(subEvent.startDateTime)
      );
    },
    getSubEventTime(subEvent) {
      return (
        new Intl.DateTimeFormat("en-US", {
          timeStyle: "short",
          timeZone: subEvent.timezone || this.currentEvent.timezone,
        }).format(subEvent.startDateTime) +
        " - " +
        new Intl.DateTimeFormat("en-US", {
          timeStyle: "short",
          timeZone: subEvent.timezone || this.currentEvent.timezone,
        }).format(subEvent.endDateTime)
      );
    },
    getNoOfSessions(subEvent) {
      if (subEvent.linkedSessions.length == 0) return "-";
      else
        return subEvent.linkedSessions.length > 1
          ? subEvent.linkedSessions.length + " sessions"
          : subEvent.linkedSessions.length + " session";
    },
    handleDelete(subEvent) {
      console.log("delete subEvent: ", subEvent);
      this.subEventToBeDeleted = subEvent;
      this.confirmationDialogTitle = "Delete " + subEvent.name + "? ";

      if (subEvent.linkedSessions.length > 0) {
        //Check if sub-event session has speakers
        let hasSpeaker = this.hasSpeaker(subEvent);
        // let hasSpeaker = false;

        console.log("hasSpeakers: ", hasSpeaker);

        if (hasSpeaker) {
          this.confirmationDialogContent =
            "All sessions and speakers associated with this sub-event will also be deleted, and will be removed from the program listing in the app.";
        } else {
          this.confirmationDialogContent =
            "All sessions associated with this sub-event will also be deleted, and will be removed from the program listing in the app.";
        }
      } else {
        this.confirmationDialogContent =
          "This sub-event will be removed from the program listing in the app.";
      }

      this.showConfirmationDialog = true;
    },
    async deleteSubEvent() {
      try {
        console.log("this.subEventToBeDeleted: ", this.subEventToBeDeleted);

        //Update linked sub-events for the parent event
        this.currentEvent.linkedSubEvents =
          this.currentEvent.linkedSubEvents.filter(
            (subEventId) => subEventId != this.subEventToBeDeleted.id
          );

        //Save sub-event
        this.currentEvent.save();

        this.showConfirmationDialog = false;

        if (this.subEventToBeDeleted.linkedSessions.length >= 1) {
          await Promise.all(
            this.subEventToBeDeleted.linkedSessions.map(async (sessionId) => {
              await this.currentEvent.deleteSession(
                sessionId,
                this.subEventToBeDeleted
              );
            })
          );
        }

        //Delete the sub-event
        // this.subEventToBeDeleted.remove();
        await deleteEventDoc(this.subEventToBeDeleted.id);

        // this.
        //   const db = firebase.firestore();
        //   let batch = db.batch();
        //   //Add sub-event doc to the batch
        //   batch.delete(db.collection("events").doc(this.subEventToBeDeleted.id));
        //   console.log("event id: ", this.subEventToBeDeleted.id);
        //   //Add linked session docs to the batch
        //   if (this.subEventToBeDeleted.linkedSessions.length > 0) {
        //     for (
        //       let i = 0;
        //       i < this.subEventToBeDeleted.linkedSessions.length;
        //       i++
        //     ) {
        //       console.log(
        //         "Session id: ",
        //         this.subEventToBeDeleted.linkedSessions[i]
        //       );
        //       batch.delete(
        //         db
        //           .collection("events")
        //           .doc(this.subEventToBeDeleted.linkedSessions[i])
        //       );
        //     }
        //   }
        //   await batch.commit();
        //   let hasSpeaker = this.hasSpeaker(this.subEventToBeDeleted);
        //   if (hasSpeaker) {
        //     let deleteindexes = [];
        //     this.currentEvent.invitees.forEach((invitee, index) => {
        //       if (
        //         this.subEventToBeDeleted.linkedSessions.includes(
        //           ...invitee.associatedSpeakerSessions
        //         )
        //       ) {
        //         deleteindexes.push(index);
        //         console.log(
        //           "delete " + invitee.firstName + " " + invitee.lastName
        //         );
        //       }
        //     });
        //     deleteindexes.forEach((itemIndex) => {
        //       this.currentEvent.invitees.splice(itemIndex, 1);
        //     });
        //     this.currentEvent.save();
        //   }
        //   this.showConfirmationDialog = false;
      } catch (error) {
        console.log("Error occurred while deleting Sub-event ", error);
        this.showConfirmationDialog = false;
      }

      this.showSnackbar({
        show: true,
        text: "Sub-event deleted successfully!",
      });
    },
    hasSpeaker(subEvent) {
      let hasSpeaker = false;
      if (subEvent.linkedSessions.length > 0) {
        for (let i = 0; i < this.currentEvent.invitees.length; i++) {
          if (
            !this.currentEvent.invitees[i].isAdmin &&
            this.currentEvent.invitees[i].associatedSubEvents.length > 0 &&
            this.currentEvent.invitees[i].associatedSubEvents.includes(
              subEvent.id
            ) &&
            subEvent.linkedSessions.length > 0
          ) {
            hasSpeaker = true;
            break;
          }
          // for (let j = 0; i < subEvent.linkedSessions.length; j++) {
          //   if (
          //     !this.currentEvent.invitees[i].isAdmin &&
          //     this.currentEvent.invitees[i].associatedSpeakerSessions.length >
          //       0 &&
          //     this.currentEvent.invitees[i].associatedSpeakerSessions.includes(
          //       subEvent.linkedSessions[j]
          //     )
          //   ) {
          //     hasSpeaker = true;
          //     break;
          //   }
          // }
          if (hasSpeaker) break;
        }
      }
      return hasSpeaker;
    },
  },
};
</script>

<style>
</style>